import request from '@/utils/request'

const chechangHikVehicle = {
  communitySelect(query) {
    return request({ url: '/chechang/hik-vehicle/communitySelect', method: 'get', params: query })
  },
  parkingSpaceSelect(query) {
    return request({ url: '/chechang/hik-vehicle/parkingSpaceSelect', method: 'get', params: query })
  },
  roomSelect(query) {
    return request({ url: '/chechang/hik-vehicle/roomSelect', method: 'get', params: query })
  },
  cityOptions(query) {
    return request({ url: '/chechang/hik-vehicle/cityOptions', method: 'get', params: query })
  },
  list(query) {
    return request({ url: '/chechang/hik-vehicle/list', method: 'get', params: query })
  },
  detail(query) {
    return request({ url: '/chechang/hik-vehicle/detail', method: 'get', params: query })
  },
  add(data) {
    return request({ url: '/chechang/hik-vehicle/add', method: 'post', data })
  },
  update(data) {
    return request({ url: '/chechang/hik-vehicle/update', method: 'post', data })
  },
  remove(data) {
    return request({ url: '/chechang/hik-vehicle/remove', method: 'post', data })
  },
  extend(data) {
    return request({ url: '/chechang/hik-vehicle/extend', method: 'post', data })
  },
  syncParkingFee(data) {
    return request({
      url: '/chechang/hik-vehicle/syncParkingFee',
      method: 'post',
      data,
      timeout: 120000
    })
  },
  statusByPlate(query) {
    return request({ url: '/chechang/hik-vehicle/statusByPlate', method: 'get', params: query })
  },
  statusCrossRecordsByPlate(query) {
    return request({ url: '/chechang/hik-vehicle/statusCrossRecordsByPlate', method: 'get', params: query })
  },
  status(query) {
    return request({ url: '/chechang/hik-vehicle/status', method: 'get', params: query })
  },
  crossRecords(query) {
    return request({ url: '/chechang/hik-vehicle/crossRecords', method: 'get', params: query })
  },
  operationLogs(query) {
    return request({ url: '/chechang/hik-vehicle/operationLogs', method: 'get', params: query })
  },
  sync(data) {
    return request({ url: '/chechang/hik-vehicle/sync', method: 'post', data })
  },
  syncProgress(query) {
    return request({ url: '/chechang/hik-vehicle/sync/progress', method: 'get', params: query })
  },
  syncHistory(query) {
    return request({ url: '/chechang/hik-vehicle/sync/history', method: 'get', params: query })
  },
  diffList(query) {
    return request({ url: '/chechang/hik-vehicle/sync/diff/list', method: 'get', params: query })
  },
  diffOverrideOne(data) {
    return request({ url: '/chechang/hik-vehicle/sync/diff/overrideOne', method: 'post', data })
  },
  diffOverrideAll(data) {
    return request({ url: '/chechang/hik-vehicle/sync/diff/overrideAll', method: 'post', data })
  },
  export(data) {
    return request({ url: '/chechang/hik-vehicle/export', method: 'post', data })
  }
}

export default chechangHikVehicle
